import { createTextComponent } from './createTextComponent';

export const BodyLarge = createTextComponent({
  styleAs: 'bodyLarge',
  tag: 'div',
});
